import {
    FETCH_AGENTS_REQUEST,
    FETCH_AGENTS_SUCCESS,
    FETCH_AGENTS_FAILURE,
    CREATE_AGENT_REQUEST,
    CREATE_AGENT_SUCCESS,
    CREATE_AGENT_FAILURE,
    UPDATE_AGENT_REQUEST,
    UPDATE_AGENT_SUCCESS,
    UPDATE_AGENT_FAILURE,
    DELETE_AGENT_REQUEST,
    DELETE_AGENT_SUCCESS,
    DELETE_AGENT_FAILURE,
  } from '../actions/agentAction';
  
  const initialState = {
    agents: [],
    loading: false,
    error: null,
  };
  
  const agentReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_AGENTS_REQUEST:
      case CREATE_AGENT_REQUEST:
      case UPDATE_AGENT_REQUEST:
      case DELETE_AGENT_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_AGENTS_SUCCESS:
        return { ...state, loading: false, agents: action.payload };
  
      case CREATE_AGENT_SUCCESS:
        return { ...state, loading: false, agents: [...state.agents, action.payload] };
  
      case UPDATE_AGENT_SUCCESS:
        return {
          ...state,
          loading: false,
          agents: state.agents.map((agent) =>
            agent.id === action.payload.id ? action.payload : agent
          ),
        };
  
      case DELETE_AGENT_SUCCESS:
        return {
          ...state,
          loading: false,
          agents: state.agents.filter((agent) => agent.id !== action.payload),
        };
  
      case FETCH_AGENTS_FAILURE:
      case CREATE_AGENT_FAILURE:
      case UPDATE_AGENT_FAILURE:
      case DELETE_AGENT_FAILURE:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default agentReducer;
  